<template>
  <div id="buyer">
    <div class="tabbar">
      <div :class="item===selectItem?'isAcitve':''" v-for="(item,index) in tabbarItem" :key="index" @click="clickItem(item,index)">
        {{item}}
      </div>
    </div>
    <div class="filter">
      <div class="select_ground">
        <div class="select_data">
          <el-select v-model="query.time_type" :popper-append-to-body="false" placeholder="选择时间" @change="handleSearch">
            <el-option
              v-for="(item,index) in options"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="select_game">
          <el-select v-model="query.game_id" clearable :popper-append-to-body="false" placeholder="选择游戏" @change="handleSearch">
            <el-option
              v-for="(item,index) in selectGame"
              :key="index"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="filter_search">
        <input type="text" class="filter_search_input" v-model="query.keyword" placeholder="请输入账户关键词">
        <span class="filter_search_btn" @click="handleSearch">确认</span>
      </div>
    </div>
    <div class="product_list">
      <el-table
        :data="tableData"
        @row-click="tablaRowClick"
        style="width: 100%">
        <!-- 空数据 -->
        <template slot="empty">
          <div class="no_data">
            <empty-state
              title="暂无购买装备"
              description="可以调整筛选条件后再次查看"
              icon="el-icon-shopping-bag-1"
              :icon-size="52">
            </empty-state>
          </div>
        </template>
        <!-- 商品信息 -->
        <el-table-column
          :label="'商品信息（'+totalCount+'条）'"
          width="570">
          <template slot-scope="scope">
            <div class="product">
              <div class="product__img">
                <!-- {{scope.row.game_image}} -->
                <el-image :src="scope.row.game_image"></el-image>
              </div>
              <div class="product_info">
                <div class="product_info_top">
                  订单号：{{ scope.row.order_no }}
                </div>
                <div class="product_info_mid">
                  <span>{{ scope.row.game_name }}</span>
                  {{ scope.row.goods_name }}
                </div>
                <div class="product_info_bot">
                  下单时间：{{ scope.row.add_time }}
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <!-- 金额 -->
        <el-table-column
          label="金额">
          <template slot-scope="scope">
            <div class="product_price">¥{{scope.row.order_amount}}</div>
          </template>
        </el-table-column>
        <!-- 状态 -->
        <el-table-column
          label="状态"
          width="111">
          <!-- eslint-disable-next-line -->
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper">
              <el-tag v-if="scope.row.order_status_for_user == '1'" type="danger" size="medium">待付款</el-tag>
              <el-tag v-if="scope.row.order_status_for_user == '2'" type="error" size="medium">待发货</el-tag>
              <el-tag v-if="scope.row.order_status_for_user == '3'" type="success" size="medium">已成交</el-tag>
              <el-tag v-if="scope.row.order_status_for_user == '4'" type="info" size="medium">已取消</el-tag>
              <el-tag v-if="scope.row.order_status_for_user == '5'" type="warning" size="medium">已退款</el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- 操作 -->
        <el-table-column
          label="操作"
          width="100">
          <template slot-scope="scope">
            <div class="btn_ground">
              <a v-if="scope.row.sys_service_type ==2||scope.row.sys_service_type == 3&&scope.row.order_status_for_user!='3'" class="ask_service cust_ask" @click.stop="cusSerBtnClicks(scope.row)">咨询客服</a>
              <a
                v-if="scope.row.sys_service_type != 2&&scope.row.order_status_for_user!='3'"
                class="ask_service cust_ask"
                @click.stop @click="$accessLink(scope.row.game_customer)"
                :href="`${scope.row.game_customer}?u_cust_id=${$store.state.userData.user_id}&u_cust_name=${$store.state.userData.nickname}`"
                target="_blank">咨询客服</a>
              <a
                class="ask_service"
                v-if="scope.row.order_status_for_user=='2'||scope.row.order_status_for_user=='3'||scope.row.order_status_for_user=='5'"
                @click.stop="goDetail(scope.row)"
                href="#">支付详情</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pages" v-if="totalCount !== 0">
        <common-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="query.page"
          :page-size="query.pageSize"
          layout="prev, pager, next, jumper"
          :total="totalCount">
        </common-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import CommonPagination from "@/components/commonPagination";
import EmptyState from "@/components/emptyState";
import {apiGameList, apiBuyOrderList} from "@/request/API";

export default {
  name: 'BuyerList',
  props: {},
  components: {
    CommonPagination,
    EmptyState
  },
  data () {
    return {
      query: {
        page: 1,
        pageSize: 10,
        order_status: 0,
        time_type: 0,
        game_id: '',
        keyword: '',
        order_type: 2
      },
      // 默认显示第几页
      // currentPage:1,
      // 总条数，根据接口获取数据长度(注意：这里不能为空)
      totalCount:0,
      // 默认每页显示的条数（可修改）
      // PageSize:10,
      // tabbar 选中项
      selectItem:'全部订单',
      // tabbar 选中项Index
      selectItemIndex: 0,
      tabbarItem:[
        '全部订单','待付款','待发货','已成交','已取消','已退款'
      ],
      //表格数据
      tableData: [],
      //选择时间下拉框
      options: [
        {value: 0, label: '全部'},
        {value: 1, label: '本周内'},
        {value: 2, label: '当月'},
        {value: 3, label: '三个月内'},
        {value: 4, label: '半年内'},
        {value: 5, label: '半年以上'},
        {value: 6, label: '一年内'},
      ],
      value: '',
      //选择游戏下拉框
      selectGame: [],
      selectGameValue: '',
      //关键词搜索
      // match:'',
      //当前页码
      // page:1
    }
  },
  methods: {
    /**
     * @description: 跳转支付详情
     * @return {*}
     */
    goDetail(row) {
      this.$router.push({
        name: 'BuyerDetail',
        query: {
          id:row.id,
          type: 2
        }
      })
    },
    cusSerBtnClicks(item) {
      this.$openIM({
        game_id: item.game_id,
        shopid: item.id,
        product_type: 2,
        gameAlias: item.one_order_info.game_alias,
      })
    },
    //table监听事件
    handleEdit(index, row) {
    },
    handleCurrentChange(val) {
      this.query.page = val
      this.handleGetData()
    },
    handleSearch() {
      this.query.page = 1
      this.handleGetData()
    },
    handleGetData() {
      apiBuyOrderList(this.query).then(res=>{
        this.tableData = res.data.data
        this.totalCount = res.data.total
        this.tableData.forEach(item => {
          if(item.one_order_info){
            item.game_image = item.one_order_info.goods_image||''
            item.goods_name = item.one_order_info.goods_name||''
          }else{
            item.game_image = ''
            item.goods_name = ''
          }
        })
      })
    },
    //表格 row 单击事件
    tablaRowClick(row, column, event){
      this.$router.push({
        name:'EquipmentDetails',
        query:{
          game_id:row.game_id,
          id:row.product_id
        }
      });
    },
    //tabbar
    clickItem(item, index) {
      //游戏列表  下拉框
      // apiGameList({
      // }).then(res=>{
      //   res.data.forEach((item,index)=>{
      //     let options = new Object()
      //     options.value = item.game_id
      //     options.label = item.game_name
      //     this.selectGame.push(options)
      //   })
      // })
      this.selectItem = item
      this.query.order_status = index
      this.handleSearch()

      // this.selectItemIndex = index
      // this.getAccountList(this.value,this.selectGameValue.value,this.match,this.selectItemIndex)
    },
    //选择时间 下拉框 监听
    // selectTimeChange(){
    //   this.getAccountList(this.value,this.selectGameValue.value,this.match,this.selectItemIndex)
    // },
    //选择游戏 下拉框 监听
    // selectGameChange(event){
    //   this.getAccountList(this.value,this.selectGameValue.value,this.match,this.selectItemIndex)
    // },
    //关键词搜索
    // clickMatch(){
    //   this.getAccountList(this.value,this.selectGameValue.value,this.match,this.selectItemIndex)
    // },
    /**
     * 获取已成交账号列表
     * @param timeType 时间下拉框
     * @param game_id  游戏下拉框
     * @param match    关键词
     */
    // getAccountList(timeType,game_id,match,billStatus){
    //   apiBuyOrderList({
    //     timeType:timeType,
    //     game_id:game_id,
    //     match:match,
    //     billStatus:billStatus
    //   }).then(res=>{
    //     this.tableData = res.data.data
    //     this.totalCount = res.data.total
    //     this.tableData.forEach(item => {
    //       item.game_image = item.one_order_info.goods_image
    //       item.goods_name = item.one_order_info.goods_name
    //     })

    //   })
    // },
    //初始化数据
    // onLoad(){
    //   //游戏列表  下拉框
    //   apiGameList({
    //   }).then(res=>{
    //     res.data.forEach((item,index)=>{
    //       let options = new Object()
    //       options.value = item.game_id
    //       options.label = item.game_name
    //       this.selectGame.push(options)
    //     })
    //   })
    //   // 已成交 账号列表
    //   apiBuyOrderList(this.query).then(res=>{
    //     this.tableData = res.data.data
    //     this.totalCount = res.data.total
    //     this.tableData.forEach(item => {
    //       item.game_image = item.one_order_info.goods_image
    //       item.goods_name = item.one_order_info.goods_name
    //     })

    //   })
    // }
  },
  created() {
    apiGameList().then(res=>{
      res.data.forEach((item,index)=>{
        let options = new Object()
        options.value = item.game_id
        options.label = item.game_name
        this.selectGame.push(options)
      })
    })
  },
  mounted () {
    //初始化数据
    if(typeof(this.$route.params.selectItem) !== 'undefined'){
      this.clickItem(this.$route.params.selectItem,this.$route.params.selectItemIndex)
    }else {
      // this.onLoad()
      this.handleGetData()
    }
  },
  watch: {

  },
  computed: {

  }
}
</script>

<style lang='less'>
.change_price_confirm{
  width: 500px !important;
  height: 320px !important;
  background: #FFFFFF !important;
  border-radius: 4px !important;
  padding: 0;
  border: none;
  overflow: hidden;
  box-shadow: none;
  filter: drop-shadow(0 18px 46px rgba(26, 29, 36, 0.14));

  .el-message-box__header>.el-message-box__title{
    display: none;
  }

  .el-message-box__header{
    height: 54px;
    padding: 0;
    background: var(--bg-dark, linear-gradient(135deg, #1A1D24 0%, #1A1D24 100%));
  }

  .el-message-box__content{
    display: flex;
    flex-direction: column;
    padding: 32px 58px 0;
  }

  .el-message-box__btns{
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px 20px 34px;
  }

  .el-message-box__title{
    margin-top: 0;
    font-size: 18px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 54px;
  }

  .el-message-box__container{
    margin-top: 0;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
  }

  .el-message-box__headerbtn{
    top: 17px;
    right: 20px;
    width: 20px;
    height: 20px;
  }

  .el-message-box__close{
    color: rgba(255, 255, 255, 0.86);
    font-size: 18px;
    transition: color .2s ease, transform .2s ease;
  }

  .el-message-box__headerbtn:hover .el-message-box__close{
    color: #FFFFFF;
    transform: rotate(90deg);
  }

  .change_price_confirm_btn{
    margin-top: 0;
    padding: 0;
    width: 200px;
    height: 40px;
    line-height: 40px;
    background: var(--primary, #FF5A1F) !important;
    border-radius: 4px;
    border: none;
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    color: #FFFFFF !important;
    transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
  }

  .change_price_confirm_btn:hover{
    background: var(--primary-hover, #E84A12) !important;
    box-shadow: 0 10px 22px rgba(255, 90, 31, 0.22);
    opacity: 1;
  }

  .confirm_content{
    display: flex;
    flex-direction: column;
  }

  .confirm_original_price{
    font-size: 20px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 600;
    color: var(--primary, #FF7A1A);
    line-height: 28px;
    margin-bottom: 20px;
  }

  .confirm_my_bid{
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-secondary, #5A5F6B);
    line-height: 22px;
    margin-bottom: 20px;
  }

  .confirm_modify_bid{
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .confirm_modify_bid_text{
    font-size: 15px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 500;
    color: var(--text-secondary, #5A5F6B);
    line-height: 40px;
  }

  .confirm_modify_bid_input{
    width: 250px;
    height: 40px;
    background: var(--bg-tag, #F7F5F2);
    border-radius: 4px;
    border: 1px solid var(--border-soft, #E8E4DE);
    padding: 0 14px;
    font-size: 14px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-main, #111827);
    line-height: 22px;
    outline: none;
    transition: border-color .2s ease, box-shadow .2s ease, background .2s ease;
  }

  .confirm_modify_bid_input:hover{
    border-color: var(--border-strong, #D8D2CA);
  }

  .confirm_modify_bid_input:focus{
    border-color: var(--primary, #FF5A1F);
    background: #FFFFFF;
    box-shadow: none;
  }

  .confirm_modify_bid_tips{
    margin-left: 75px;
    font-size: 13px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: var(--text-muted, #9AA0AC);
    line-height: 20px;
  }

  .confirm_modify_bid_input::-webkit-input-placeholder {
    font-size: 14px;
    color: var(--text-muted, #9AA0AC);
  }
}
</style>

<style lang='less' scoped>
#buyer{
  padding: 20px;
  display: flex;
  flex-direction: column;
  color: var(--text-main, #111827);

  *,
  *:before,
  *:after{
    box-sizing: border-box;
  }

  .tabbar{
    min-height: 40px;
    height: auto;
    margin-top: 0;
    padding: 4px 0 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    background: transparent;
    border: none;
    border-radius: 0;
    overflow: visible;

    div{
      min-width: 84px;
      height: 34px;
      margin-right: 0;
      padding: 0 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      border-radius: 4px;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-secondary, #5A5F6B);
      line-height: 20px;
      cursor: pointer;
      transition: color .2s ease, background .2s ease, box-shadow .2s ease;
    }

    div:hover{
      color: var(--text-main, #1A1D24);
      background: var(--bg-tag, #F0EDE8);
    }

    .isAcitve,
    .isAcitve:hover{
      padding-bottom: 0;
      color: #FFFFFF;
      font-size: 14px;
      font-weight: 500;
      background: var(--bg-dark, #1A1D24);
      box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
      border-bottom: 3px solid var(--primary, #FF5A1F);
    }
  }

  .filter{
    min-height: 40px;
    height: auto;
    margin: 18px 0;
    padding: 0;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
    background: transparent;
    border: none;
    border-radius: 0;

    .select_ground{
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 12px;

      .select_data{
        margin-right: 0;
      }

      /deep/.el-input__inner{
        width: 180px;
        height: 40px;
        padding: 0 34px 0 14px;
        background: var(--bg-card, #FFFFFF);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        color: var(--text-main, #111827);
        font-size: 14px;
        transition: border-color .2s ease, box-shadow .2s ease;
      }

      /deep/.el-input.is-focus .el-input__inner,
      /deep/.el-input__inner:focus{
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      /deep/.popper__arrow{
        left: 155px !important;
      }

      /deep/.el-select-dropdown{
        border-color: var(--border-soft, #E8E4DE);
        border-radius: 4px;
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      }

      /deep/.el-select-dropdown__item{
        color: var(--text-secondary, #5A5F6B);
      }

      /deep/.el-select-dropdown__item.hover,
      /deep/.el-select-dropdown__item:hover{
        background: var(--bg-tag, #F0EDE8);
      }

      /deep/.el-select-dropdown__item.selected{
        color: var(--primary, #FF5A1F);
        font-weight: 500;
      }
    }

    .filter_search{
      width: 318px;
      height: 40px;
      display: flex;
      flex-direction: row;
      align-items: center;
      flex-shrink: 0;
      position: static;
      overflow: hidden;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;
      transition: border-color .2s ease, box-shadow .2s ease;

      &:focus-within{
        border-color: var(--primary, #FF5A1F);
        box-shadow: none;
      }

      .filter_search_input{
        width: 100%;
        min-width: 0;
        height: 38px;
        padding: 0 16px;
        background: transparent;
        border: none;
        outline: none;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        color: var(--text-main, #111827);
      }

      .filter_search_input::-webkit-input-placeholder{
        font-size: 14px;
        color: var(--text-muted, #9AA0AC);
      }

      .filter_search_btn{
        position: static;
        width: 92px;
        height: 32px;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        background: var(--primary, #FF5A1F);
        border-radius: 4px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
        box-shadow: none;
        transition: box-shadow .2s ease, opacity .2s ease, background .2s ease;
      }

      .filter_search_btn:hover{
        opacity: 1;
        background: var(--primary-hover, #E84A12);
      }
    }
  }

  .product_list{
    overflow: hidden;
    border: 1px solid var(--border-soft, #E8E4DE);
    border-radius: 4px;
    background: var(--bg-card, #FFFFFF);

    /deep/.el-table{
      color: var(--text-main, #111827);
    }

    /deep/.el-table:before{
      display: none;
    }

    /deep/.el-table th{
      height: 48px;
      background: var(--bg-tag, #F7F5F2);
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-secondary, #5A5F6B);
    }

    /deep/.el-table th>.cell,
    /deep/.el-table .cell{
      padding: 0;
      text-align: center;
    }

    /deep/.el-table td{
      padding: 0;
      border-bottom: 1px solid var(--border-soft, #E8E4DE);
    }

    /deep/.el-table__row:hover td{
      background: var(--bg-tag, #F7F5F2);
    }

    /deep/.el-tag{
      height: 28px;
      padding: 0 10px;
      display: inline-flex;
      align-items: center;
      border: none;
      border-radius: 4px;
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-main, #1A1D24);
      font-size: 13px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
    }

    /deep/.el-tag.el-tag--danger{
      background: var(--primary-soft, #FCEDE5);
      color: var(--gold, #C9974D);
    }

    /deep/.el-tag.el-tag--error{
      background: var(--primary-soft, #FCEDE5);
      color: var(--primary, #FF5A1F);
    }

    /deep/.el-tag.el-tag--info{
      background: var(--bg-tag, #F0EDE8);
      color: var(--text-muted, #9AA0AC);
    }

    /deep/.el-tag.el-tag--success{
      background: var(--success-soft, #ECFDF5);
      color: var(--new, #00C16E);
    }

    /deep/.el-tag.el-tag--warning{
      background: #FFE9ED;
      color: var(--hot, #FF2D55);
    }

    .product{
      height: 168px;
      padding: 18px 0 18px 18px;
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .product__img{
      width: 124px;
      height: 124px;
      margin-right: 18px;
      flex: 0 0 124px;
      overflow: hidden;
      background: var(--bg-tag, #F0EDE8);
      border: 1px solid var(--border-soft, #E8E4DE);
      border-radius: 4px;

      img,
      /deep/.el-image{
        height: 100%;
        width: 100%;
        display: block;
        object-fit: cover;
        border-radius: 0;
      }
    }

    .product_info{
      width: 420px;
      height: 124px;
      min-width: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .product_info_top{
      height: 24px;
      margin: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: left;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      line-height: 24px;
    }

    .product_info_mid{
      height: 54px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      text-align: left;
      font-size: 15px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 500;
      color: var(--text-main, #111827);
      line-height: 27px;

      span{
        height: 22px;
        margin: 2px 8px 0 0;
        padding: 2px 8px;
        display: inline-flex;
        align-items: center;
        vertical-align: top;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-main, #1A1D24);
        line-height: 18px;
        background: var(--bg-tag, #F0EDE8);
        border-radius: 4px;
      }
    }

    .product_info_bot{
      min-height: 22px;
      font-size: 12px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: var(--text-muted, #9AA0AC);
      line-height: 22px;
      text-align: left;
      white-space: nowrap;
    }

    .product_price{
      font-size: 20px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 600;
      color: var(--primary, #FF7A1A);
      line-height: 28px;
    }

    .btn_ground{
      min-height: 74px;
      padding: 8px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      gap: 8px;

      div,
      a{
        min-width: 82px;
        height: 30px;
        padding: 0 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-size: 13px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 500;
        line-height: 20px;
        text-align: center;
        text-decoration: none;
        cursor: pointer;
        transition: border-color .2s ease, box-shadow .2s ease, opacity .2s ease, background .2s ease, color .2s ease;
      }

      div:hover,
      a:hover{
        opacity: .92;
      }

      .ask_service{
        color: #FFFFFF;
        background: var(--primary, #FF5A1F);
        border: 1px solid transparent;
        box-shadow: none;
      }

      .ask_service:hover{
        background: var(--primary-hover, #E84A12);
        opacity: 1;
      }

      .cust_ask{
        color: var(--text-main, #1A1D24);
        background: var(--bg-card, #FFFFFF);
        border: 1.5px solid var(--bg-dark, #1A1D24);
        box-shadow: none;
      }

      .cust_ask:hover{
        color: var(--text-main, #1A1D24);
        background: var(--bg-tag, #F0EDE8);
        border-color: var(--bg-dark, #1A1D24);
      }
    }

    .pages{
      min-height: 88px;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      background: var(--bg-card, #FFFFFF);
    }

    .no_data{
      min-height: 300px;
      padding: 64px 36px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
